import config from '../../../config';

export default {
  namespaced: true,
  state: {
    // 是否允许用户配置
    allowSetting: false,
    // 是否移动端
    isMobile: false,
    // 是否收起菜单
    isSmallLaptop: false,
    // 主题
    theme: 'dark',
    // ？
    layout: 'side',
    // 固定Siderbar/Header
    fixedSider: true,
    fixedHeader: true,
    // 系统名称
    systemName: config.title || '生学教育大数据中心',
    // 是否显示打开菜单的标签栏
    multipage: false,
    copyright: '2018 @sxw.cn 前端',
    footerLinks: [
      { link: 'http://edu.sxw.cn', name: '生学网' }
    ]
  },
  mutations: {
    setMobileDevice(state, isMobile) {
      state.isMobile = isMobile;
    },
    setSmallLaptopDevice(state, isSmallLaptop) {
      state.isSmallLaptop = isSmallLaptop;
    },
    setTheme(state, theme) {
      state.theme = theme;
    },
    setLayout(state, layout) {
      state.layout = layout;
    },
    setFixedSider(state, fixedSider) {
      if (state.layout !== 'side') {
        fixedSider = false;
      }
      state.fixedSider = fixedSider;
    },
    setFixedHeader(state, fixedHeader) {
      state.fixedHeader = fixedHeader;
    },
    setMultipage(state, multipage) {
      state.multipage = multipage;
    }
  }
};
